import { render, staticRenderFns } from "./DeleteLeaderDialog.vue?vue&type=template&id=74590a32&scoped=true&"
import script from "./DeleteLeaderDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteLeaderDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74590a32",
  null
  
)

export default component.exports